import React, { useRef } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  ParagraphText,
  HeadingText,
  Button,
  Tooltip,
  HeadingBar,
} from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { COB_LIBRARY_ASSET_KEYS } from '../../types/cob-library.types';
import useCobStore from '../../store/cob-store';
import COBQuestioner from '../../assets/json/COB_QUESTIONER.json';

export function ConfirmationModal(props: any) {
  const { hideClose, successModal, showClose } = props;
  const navigate = useNavigate();
  const resetInitialState = useCobStore((state: any) => state.resetState);
  const myRef = useRef<HTMLDivElement>(null);
  // const [setMyComponentWidth] = useState('');
  const historyClose = () => {
    localStorage.clear();
    resetInitialState();
    navigate(-1);
  };

  const showhistoryBackClose =
    showClose === true && successModal ? 'none' : 'block';
  const crossIcon = useStaticAsset(COB_LIBRARY_ASSET_KEYS.CROSS_ICON) as string;
  return (
    <Modal.Root data-testid="confirmation_modal">
      <Modal.Trigger>
        <div
          style={{
            display: hideClose ? 'none' : 'block',
            width: '100%',
            textAlign: 'right',
            border: '0px #000000 solid',
          }}
        >
          <Box
            ref={myRef}
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                '@desktop': {
                  width: '55%',
                  left:
                    Number(myRef.current?.offsetWidth) > 36 ? '410px' : '510px',
                  marginBottom:
                    Number(myRef.current?.offsetWidth) > 36 ? '-19px' : '1px',
                  marginLeft:
                    Number(myRef.current?.offsetWidth) > 36 ? '-10px' : '10px',
                },
                '@mobile': {
                  marginTop:
                    Number(myRef.current?.offsetWidth) === 338
                      ? '20px'
                      : '40px',
                  marginLeft:
                    Number(myRef.current?.offsetWidth) === 338
                      ? '370px'
                      : '290px',
                  paddingBottom:
                    Number(myRef.current?.offsetWidth) === 338 ? '0px' : '0px',
                  paddingTop:
                    Number(myRef.current?.offsetWidth) === 338 ? '0px' : '30px',
                  marginRight:
                    Number(myRef.current?.offsetWidth) === 338 ? '0px' : '12px',
                  position:
                    Number(myRef.current?.offsetWidth) === 338
                      ? 'relative'
                      : 'relative',
                  // right: checkResolution(),
                  zIndex:
                    Number(myRef.current?.offsetWidth) === 338 ? '' : '10',
                },
                '@media only screen and (max-width: 354px) and (min-width: 300px)':
                  {
                    right: '35px',
                  },
                '@media only screen and (min-width: 355px) and (min-width: 355px)':
                  {
                    right:
                      Number(myRef.current?.offsetWidth) === 48 ||
                      Number(myRef.current?.offsetWidth) === 74
                        ? '0px'
                        : '50px',
                  },
                '@media only screen and (max-width: 400px) and (min-width: 356px)':
                  {
                    width: '93px',
                    right: '0px',
                    marginLeft: successModal === true ? '335px' : '300px',
                  },
                '@media only screen and (max-width: 440px) and (min-width: 401px)':
                  {
                    right: '15px',
                  },
                '@media only screen and (max-width: 1843px) and (min-width: 820px)':
                  {
                    width: '25%',
                  },
                '@media only screen and (max-width: 1024px) and (min-width: 480px)':
                  {
                    width: '50%',
                  },
                '@media only screen and (max-width: 1280px) and (min-width: 1024px)':
                  {
                    position: 'relative',
                    zIndex: '9999',
                    width: '100%',
                  },
                '@media only screen and (max-width: 1024px) and (min-width: 640px)':
                  {
                    position: 'relative',
                    zIndex: '9999',
                    width: '100%',
                  },
              } as GDSStyleObject
            }
          >
            <Tooltip
              align="start"
              side="bottom"
              content="close"
              avoidCollisions
            >
              {showClose && successModal ? (
                <Button
                  priority="secondary"
                  quiet
                  size="toolbar"
                  tabIndex={0}
                  onClick={historyClose}
                  css={{ display: 'block' }}
                >
                  <img src={crossIcon} alt="close the online form" />
                </Button>
              ) : (
                <Button
                  priority="secondary"
                  quiet
                  size="toolbar"
                  tabIndex={0}
                  css={{ display: showhistoryBackClose }}
                >
                  <img src={crossIcon} alt="close the online form" />
                </Button>
              )}
            </Tooltip>
          </Box>
        </div>
      </Modal.Trigger>
      <Modal.Content
        showCloseButton={false}
        padding="$none"
        layout={{ '@initial': 'standard', '@mobile': 'fullscreen' }}
        width={{ '@initial': 588, '@mobile': '100%' }}
        css={{
          '.GDS-modal-overlay': { background: 'rgba(149, 149, 149, 0.46)' },
        }}
      >
        <Tooltip
          css={{ zIndex: '9999999' }}
          align="end"
          avoidCollisions
          content="close"
          side="bottom"
        >
          <HeadingBar
            rightAction={
              <Modal.Close>
                <Button
                  priority="tertiary"
                  quiet
                  icon="tinyClose"
                  hideLabel
                  size="small"
                >
                  Close
                </Button>
              </Modal.Close>
            }
          />
        </Tooltip>
        <StackLayout
          css={{ textAlign: 'center', padding: '$two $two' }}
          horizontalAlignment="stretch"
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              } as GDSStyleObject
            }
          >
            {' '}
            <img
              src={
                useStaticAsset(COB_LIBRARY_ASSET_KEYS.EXIT_WARNING) as string
              }
              alt="cross icon"
              width="158px"
              style={{ cursor: 'pointer' }}
            />
          </Box>
          <Modal.Title>
            <HeadingText
              level="display"
              size="sm"
              css={{ padding: '$oneAndHalf $none' } as GDSStyleObject}
            >
              {COBQuestioner.COB.ALERT.HEADING}
            </HeadingText>
          </Modal.Title>
          <ParagraphText emphasis="subtle">
            {COBQuestioner.COB.ALERT.CONTENT}
          </ParagraphText>

          {/* <Responsive up="mobile"> */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              paddingRight: '10px',
              marginTop: '48px',
            }}
          >
            <Modal.Close>
              <Button
                size="large"
                priority="secondary"
                css={{
                  color: '#434B51',
                  border: '1px #434B51 solid',
                  alignSelf: '',
                  marginRight: '10px',
                  height: '40px',
                  left: '100px',
                }}
              >
                {COBQuestioner.COB.Buttons.CANCEL}
              </Button>
            </Modal.Close>
            <Button
              size="large"
              priority="primary"
              css={{
                background: '$interactiveActionPrimary',
                height: '40px',
                left: '100px',
              }}
              onClick={historyClose}
            >
              {COBQuestioner.COB.Buttons.CLOSE}
            </Button>
          </div>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
}
